<template>
  <header>
    <component class="heading" :is="type">
      <slot/>
    </component>
  </header>
</template>

<script>
export default {
  name: 'Heading',
  components: {},
  props: {
    type: {
      type: String,
      default: 'h1'
    }
  },
  mounted () {},
  data: () => ({})
}
</script>

<style lang="scss">
    @import "./heading";
</style>



// WEBPACK FOOTER //
// src/components/Heading/heading.vue